import { CountryCode } from '../common-types/country-codes';
import { availableCurrencies, Currency } from '../common-types/currency';

export const formatCurrency = (currency: Currency, number: string | number): string => {

    if(!number) {
        return '';
    }

    let cleanNumber = typeof number === 'string' ? parseFloat(number) : number;

    let currencyObject = availableCurrencies.find(c => c.code == currency);

    if(!currencyObject) {
        return `${cleanNumber} ${currency}`;
    }
    
    const formatNumber = (number: number): string => {
        let [integer, decimal] = number.toLocaleString('en', { minimumFractionDigits: currencyObject.decimals, maximumFractionDigits: currencyObject.decimals }).split('.');
        return `${integer.replace(/,/g, currencyObject.thousandsSeparator)}${currencyObject.showDecimalsOnZero || (Number(decimal) > 0) ? `${currencyObject.decimalSeparator}${decimal}` : ''}`;
    };

    return currencyObject.prefix 
        ? `${currencyObject.symbol}${formatNumber(cleanNumber)}` 
        : `${formatNumber(cleanNumber)}${currencyObject.symbol}`; 
};


/*
export const formatCurrency = (currency: Currency, number: string | number): string => {
    let cleanNumber: number = 0;

    if (number) {
        cleanNumber = typeof number === 'string' ? parseFloat(number) : number;
    }

    const split = (value: string): string => {
        const stripped = value.replace(',00', '');
        const parts = stripped.split(' ');

        if (parts.length >= 2 && parts.length <= 10) {
            return parts.join(' ');
        }
        return parts[0] || stripped;
    };

    const numberString = cleanNumber !== parseInt(cleanNumber.toString()) ? cleanNumber.toFixed(2) : cleanNumber.toString();

    if (currency) {
        let price = parseFloat(numberString).toLocaleString('en', { minimumFractionDigits: 2 }).split(',').join(' ').split('.').join(',');
        switch (currency.toLowerCase()) {
            case 'sek':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} kr`;
            case 'nok':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} kr`;
            case 'dkk':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} DKK`;
            case 'eur':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} €`;
            case 'usd':
            case 'mxn':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `$${price}`;
            case 'chf':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `CHF ${price}`;
            case 'aed':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} AED`;
            case 'nzd':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `NZ$${price}`;
            case 'gbp':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `£${price}`;
            case 'sar':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} SAR`;
            case 'inr':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `₹${price.replace(',', '.').replace(' ', ',')}`;
            case 'czk':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `Kč ${price}`;
            case 'cad':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `$${price}`;
            case 'ron':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} Lei`;
            case 'huf':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} HUF`;
            case 'xcq':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} XCQ`;
            case 'tl':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} TL`;
            case 'dzd':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} DA`;
            case 'xcg':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} XCG`;
            case 'pln':
                if (price.endsWith(',00')) {
                    price = split(price);
                }
                return `${price} PLN`;
        }
    }
    return cleanNumber.toString();
}; */

export const getCurrencySymbol = (currency: Currency): { symbol: string; prefix?: boolean } => {
    let curr = availableCurrencies.find(c => c.code == currency);
    if(!curr) {
        return {
            symbol: '€',
            prefix: false
        };
    }

    return {
        symbol: curr.symbol,
        prefix: curr.prefix
    };
};

export const currencyFromCountry = (country: CountryCode): Currency => {
    switch (country) {
        case 'ae':
            return 'aed';
        case 'ch':
            return 'eur';
        case 'de':
            return 'eur';
        case 'dk':
            return 'dkk';
        case 'fi':
            return 'eur';
        case 'fr':
            return 'eur';
        case 'nl':
            return 'eur';
        case 'no':
            return 'nok';
        case 'se':
            return 'sek';
        case 'be':
            return 'eur';
        case 'nz':
            return 'nzd';
        case 'gb':
            return 'gbp';
        case 'in':
            return 'inr';
        case 'cz':
            return 'czk';
        case 'kr':
            return 'krw';
        case 'th':
            return 'thb';
        case 'ca':
            return 'cad';
        case 'ro':
            return 'ron';
        case 'hu':
            return 'huf';
        case 'cw':
            return 'xcq';
        case 'si':
            return 'eur';
        case 'mx':
            return 'mxn';
        case 'pl':
            return 'pln';
        default:
            return 'eur';
    }
};
